<div class="wrapper" [ngClass]="[type(), inlineClass(), variantClass(), iconSizeClass(), textClass()]">
    <div class="icon">
        <mat-icon [svgIcon]="icon()"></mat-icon>
    </div>
    {{ text() }}
</div>
